import { Dispatch } from 'redux';
import { MenuQuery } from '../../../../services/query';
import { setNavigateUrls } from '../common/_authorizationActions';

export const FETCH_LEFT_MENU_REQUEST = 'FETCH_LEFT_MENU_REQUEST';
export const FETCH_LEFT_MENU_SUCCESS = 'FETCH_LEFT_MENU_SUCCESS';
export const FETCH_LEFT_MENU_FAILURE = 'FETCH_LEFT_MENU_FAILURE';

export const fetchLeftMenuRequest = () => ({
    type: FETCH_LEFT_MENU_REQUEST,
});

export const fetchLeftMenuSuccess = (menu: any) => {
    console.log('fetchLeftMenuSuccess - Menu Data:', menu);
    return {
        type: FETCH_LEFT_MENU_SUCCESS,
        payload: menu,
    };
};

export const fetchLeftMenuFailure = (error: any) => ({
    type: FETCH_LEFT_MENU_FAILURE,
    payload: error,
});

// Thunk Action
export const fetchLeftMenu = (resetCache: boolean = false) => {
    return async (dispatch: Dispatch) => {
        dispatch(fetchLeftMenuRequest());
        try {
            console.log('Fetching menu list...', resetCache ? '(with cache reset)' : '');
            const res = await MenuQuery.GetMenuList(resetCache ? { resetcache: true } : undefined);
            console.log('Menu API Response:', res);

            if (res && Array.isArray(res) && res.length > 0) {
                const menuWithHidden = res.map((item: any) => ({
                    ...item,
                    isHidden: item.isHidden || false,
                }));
                console.log('Processed menu with isHidden:', menuWithHidden);
                dispatch(fetchLeftMenuSuccess(menuWithHidden));

                const navigateUrls = extractNavigateUrls(menuWithHidden);
                console.log('Extracted URLs before dispatch:', navigateUrls);
                dispatch(setNavigateUrls(navigateUrls));
            } else {
                console.warn('Menu list is empty or invalid:', res);
                throw new Error('Menu list is empty or invalid');
            }
        } catch (error) {
            console.error('Error fetching menu:', error);
            dispatch(fetchLeftMenuFailure(error));
        }
    };
};

const extractNavigateUrls = (menuItems: any[]): string[] => {
    const urls: string[] = [];

    const extractUrls = (items: any[]) => {
        items.forEach((item) => {
            if (item.navigateViewUrl?.trim().length > 0) {
                urls.push(item.navigateViewUrl);
            }

            if (item.items?.menuItem) {
                extractUrls(item.items.menuItem);
            }
        });
    };

    extractUrls(menuItems);

    if (urls.includes('/sitemanagement/authorization-rule-management')) {
        urls.push('/sitemanagement/edit-user');
        urls.push('/sitemanagement/authorization-manage');
    }
    if (urls.includes('/returnList')) {
        urls.push('/returnDetail');
        urls.push('/refund');
        urls.push('/refundV2');
    }
    if (urls.includes('/productSearch')) {
        urls.push('/productDetail/:optionId');
    }
    if (urls.includes('/emailTemplateBuilder')) {
        urls.push('/emailTemplateBuilder/templateGallery');
        urls.push('/emailTemplateBuilder/createTemplate');
        urls.push('/emailTemplateBuilder/sectionGallery');
        urls.push('/emailTemplateBuilder/addSection');
        urls.push('/emailTemplateBuilder/send-test-mail/:templateKey');
        urls.push('/emailTemplateBuilder/editSection/:sectionId');
    }
    if (urls.includes('/storeCustomerManagement')) {
        urls.push('/store-customer-management');
    }

    return urls;
};
